<template lang="pug">
  v-container
    v-row
      v-col
        v-row(justify='center')
          v-spacer
          h1 Árbol de contenido
          v-spacer        
        v-row
          v-timeline( dense align-top )
            Elemento( :contenedor='$contenido' clave='Contenido' :nudo_principal='true' )
  
              
</template>
<script>
  export default {
    components: {
      Elemento: ()=>import('./componentes/elemento')
    },
   
  }
</script>